export * from './app-sidebar-minimizer.component';



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/srd-proinvel-pipeline/src/app/components/app-sidebar-minimizer/index.ts